import { NEW_SELLER_SINCE_THRESHOLD } from '../constants/itemConstants.ts';

export const getIsNewSeller = monthsSinceStartDate => {
    if (!monthsSinceStartDate) {
        return false;
    }

    return monthsSinceStartDate <= NEW_SELLER_SINCE_THRESHOLD;
};
